/**
 * Schema: Rewards JS
 * -----------------------------------------------------------------------------
 * Javascript for loyalty lion rewards.
 */
document.addEventListener('DOMContentLoaded', () => {
  waitForElm('.lion-rewards-list').then(() => {
    initRewardsList();
  });

  waitForElm('.lion-claimed-rewards-list').then(() => {
    initRewardsList();
  });

  waitForElm('.lion-tier-benefits-compare').then((elm) => {
    initRewardsCompare(elm);
    
    if (window.loyaltylion?.customer && window.customerLoggedIn) {
      initCustomerWelcome();
    }
  });

  waitForElm('.lion-rules-list').then((elm) => {
    initRewardsRulesList(elm);
  });
});

function initCustomerWelcome() {
  const heading = document.querySelector('.banner .banner__heading');
  const subheading = document.querySelector('.banner .banner__text p');
  const button = document.querySelector('.banner .banner__buttons .button');
  const buttonContainer = document.querySelector('.banner .banner__buttons');
  const newBtn = document.createElement('a');
  const howToUseDesc = [...document.querySelectorAll('.featured-collections .collection__description p')];

  if (heading) {
    heading.textContent = `Welcome back ${window.loyaltylion?.customer?.firstName},`;
  }
  if (subheading) {
    subheading.innerHTML = `You have <strong>${window.loyaltylion?.customer?.pointsApproved} Points</strong> and currently are in the <strong>${window.loyaltylionTier} tier.</strong>`;
  }
  if (button) {
    button.textContent = 'Redeem Rewards';
    button.href = '/account#redeemRewards';
    newBtn.innerHTML = 'Redemption History';
    newBtn.className = 'button button--tertiary transparent';
    newBtn.href = '/account#redemptionHistory';
    button.parentNode.insertBefore(newBtn, button.nextSibling);
  }
  if (buttonContainer) {
    buttonContainer.classList.add('banner__buttons--multiple');
    buttonContainer.style.marginTop = '0';
  }

  howToUseDesc.forEach((item) => {
    if (item.textContent === 'Create an account or log in to redeem your rewards.') {
      item.textContent = window.customerStrings.howToUseDesc;
    }
  });
}

function waitForElm(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
    }
    const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
            observer.disconnect();
            resolve(document.querySelector(selector));
        }
    });
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
  });
}

function initRewardsList() {
  const items = [...document.querySelectorAll('[data-reward-id')];
  const blocks = window.rewardsBlocks || [];

  items.forEach((item) => {
    const id = item.dataset.rewardId;
    const childSettings = blocks.find(
      (block) => block.reward_id?.toString() === id?.toString()
    );

    if (childSettings) {
      applyCustomStyles(item, childSettings);

      setTimeout(() => {
        item.style.display = 'flex';
        item.classList.add('expanded');
      }, 10);
    }
  });
}

function applyCustomStyles(item, settings) {
  const icon = item.querySelector('.lion-icon__reward');
  const title = item.querySelector('[class*=__title]');

  if (settings.title && title) {
    title.innerHTML = `${settings.title}<div class="lion-reward-item__meta">${settings.info}</div>`;
  }

  if (settings.image && icon) {
    icon.style.backgroundImage = `url(${settings.image})`;
  }
}

function initRewardsCompare(elm) {
  const headers = [...elm.querySelectorAll('.lion-tier-compare__header-cell')];

  headers.forEach((header, index) => {
    if (index === 0) { return; }
    const points = window.loyaltylion.program.loyaltyTiers[index - 1].bounds.lower;

    if (points >= 0) {
      const button = `<span class="lion-tier-points__badge">${points} Points</span>`;
      header.innerHTML += button;
    }
  });
}

function initRewardsRulesList(elm) {
  const rules = [...elm.querySelectorAll('.lion-rule-item')];
  const completedButtonMarkup = `<button class="lion-action-button lion-action-button--tile lion-action-button--disabled lion-action-button--completed" data-testid="rule-item-button"><span class="lion-rule-item__completed" data-i18n-key="ui.general.completed">Completed</span></button>`;

  rules.forEach((rule) => {
    const actions = rule.querySelector('.lion-rule-item__actions');
    const icon = rule.querySelector('.lion-rule-item__icon');
    const id = rule.dataset.ruleId;
    const redeemedMarkup = rule.querySelector('.lion-rule-item__completed');
    const settings = window.rewardsRules.find(
      (item) => item.title.toString() === id.toString()
    );

    if (actions?.innerHTML === '') {
      actions.innerHTML += completedButtonMarkup;
    }

    const redeemed =
      window.loyaltylion.customer &&
      window.loyaltylion.customer.completedRules.find(
        (item) => item.ruleId.toString() === id.toString()
      ) &&
      !redeemedMarkup.length > 0
        ? true
        : false;

    if (!settings) return;
    const image = settings.image;
    const button = settings.button;

    const buttonURL = settings.url;
    let handleClick = '';
    if (buttonURL) {
      handleClick = `onclick="window.location.href = '${buttonURL}'"`;
    }

    const buttonMarkup = `<div class="lion-rule-item__actions"><button ${handleClick} class="lion-action-button lion-action-button--tile" data-testid="rule-item-button">${button}</button></div>`;
    if (image) {
      icon.style.backgroundImage = `url(${image})`;
    }

    if (window.loyaltylion.customer && (button != '' || redeemed)) {
      actions.innerHTML = (redeemed ? completedButtonMarkup : buttonMarkup);
    }
  });
}
